"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OAuthHandler = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var OAuthHandler = /*#__PURE__*/function () {
  function OAuthHandler(provider) {
    (0, _classCallCheck2.default)(this, OAuthHandler);

    if (!provider) {
      throw new Error('You must specify provider');
    }

    this.provider = provider;
  }

  (0, _createClass2.default)(OAuthHandler, [{
    key: "isLoggedIn",
    value: function isLoggedIn() {
      throw new Error('Implementation missing');
    }
  }, {
    key: "displayLoginPage",
    value: function displayLoginPage() {
      throw new Error('Implementation missing');
    }
  }, {
    key: "signOut",
    value: function signOut() {
      throw new Error('Implementation missing');
    }
  }, {
    key: "getAccessToken",
    value: function getAccessToken() {
      throw new Error('Implementation missing');
    }
  }, {
    key: "hasValidToken",
    value: function hasValidToken() {
      throw new Error('Implementation missing');
    }
  }, {
    key: "acquireNewToken",
    value: function acquireNewToken() {
      throw new Error('Implementation missing');
    }
  }, {
    key: "renewToken",
    value: function renewToken() {
      throw new Error('Implementation missing');
    }
  }]);
  return OAuthHandler;
}();

exports.OAuthHandler = OAuthHandler;
//# sourceMappingURL=oauth-handler.js.map